import { Injectable } from '@angular/core';
import { CCMonth } from '@library-shared/models/cc-month';
import { CCYear } from '@library-shared/models/cc-year';
import { vSession } from '@models/Views/vSession';
import moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { AuthenticationService } from './authentication/authentication.service';
import { SiteService } from './site/site.service';

@Injectable({
    providedIn: 'root',
})
export class GlobalService {
    public static readonly zeroGuid = '00000000-0000-0000-0000-000000000000';
    public authenticated = false;
    public authenticationToken: string;

    constructor(private authenticationService: AuthenticationService, private siteService: SiteService) {}

    public reloadSite = false;

    private _authenticatedSession: vSession = null;

    public AuthenticatedSession(forceReload?: boolean): Observable<vSession> {
        const subject = new Subject<vSession>();

        if (this._authenticatedSession && !forceReload) {
            setTimeout(() => {
                subject.next(this._authenticatedSession);
            }, 0);
        } else {
            this.authenticationService.AuthenticatedSession().subscribe((data) => {
                this._authenticatedSession = data.record;
                subject.next(this._authenticatedSession);
            });
        }

        return subject.asObservable();
    }

    public monthList(): CCMonth[] {
        const list: CCMonth[] = [];

        for (let x = 1; x <= 12; x++) {
            list.push({
                monthName: moment(x + '/1/2017').format('MMM') + ` (${x})`,
                monthValue: x,
            });
        }

        return list;
    }

    public yearList(): CCYear[] {
        const list: CCYear[] = [];
        const startYear = new Date().getFullYear();

        for (let x = startYear; x <= startYear + 15; x++) {
            list.push({
                yearName: '' + x,
                yearValue: x,
            });
        }

        return list;
    }
}
